const ULIDRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/i

function isULID(value: string): boolean {
  return typeof value === 'string' && ULIDRegex.test(value)
}

export { isULID }
